import React, { useState, useEffect } from 'react';
import { Card, List, Badge, Typography, Space, Tag, Button, Empty, Spin } from 'antd';
import { BellOutlined, CheckOutlined } from '@ant-design/icons';
import api from '../utils/api';

const { Title, Text } = Typography;

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    setLoading(true);
    try {
      const response = await api.get('/api/notifications');
      setNotifications(response.data);
    } catch (error) {
      console.error('Error fetching notifications:', error);
    } finally {
      setLoading(false);
    }
  };

  const markAsRead = async (notificationId) => {
    try {
      await api.post(`/api/notifications/${notificationId}/read`);
      setNotifications(prev =>
        prev.map(notification =>
          notification.id === notificationId
            ? { ...notification, read: true }
            : notification
        )
      );
    } catch (error) {
      console.error('Error marking notification as read:', error);
    }
  };

  const getNotificationTypeColor = (type) => {
    const colors = {
      info: 'blue',
      warning: 'orange',
      error: 'red',
      success: 'green',
    };
    return colors[type] || 'default';
  };

  return (
    <Card className="notifications-container">
      <Space direction="vertical" style={{ width: '100%' }} size="large">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Title level={2}>
            <Space>
              <BellOutlined />
              Notifications
              {notifications.filter(n => !n.read).length > 0 && (
                <Badge count={notifications.filter(n => !n.read).length} />
              )}
            </Space>
          </Title>
        </div>

        <Spin spinning={loading}>
          {notifications.length > 0 ? (
            <List
              itemLayout="horizontal"
              dataSource={notifications}
              renderItem={notification => (
                <List.Item
                  actions={[
                    !notification.read && (
                      <Button
                        type="text"
                        icon={<CheckOutlined />}
                        onClick={() => markAsRead(notification.id)}
                      >
                        Mark as Read
                      </Button>
                    )
                  ]}
                >
                  <List.Item.Meta
                    title={
                      <Space>
                        {notification.title}
                        <Tag color={getNotificationTypeColor(notification.type)}>
                          {notification.type.toUpperCase()}
                        </Tag>
                        {!notification.read && (
                          <Badge status="processing" text="New" />
                        )}
                      </Space>
                    }
                    description={
                      <Space direction="vertical">
                        <Text>{notification.message}</Text>
                        <Text type="secondary">
                          {new Date(notification.created_at).toLocaleString()}
                        </Text>
                      </Space>
                    }
                  />
                </List.Item>
              )}
            />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No notifications"
            />
          )}
        </Spin>
      </Space>
    </Card>
  );
};

export default Notifications;
